export { default } from './UserAgreement';
